// Tooltip - used as jQuery plugin for theme compatibility ($.fn.tooltip)
export function registerTooltipPlugin($) {
  const methods = {
    init() {
      this.each(function () {
        const el = $(this);
        el.data('tooltip', { title: el.attr('title') }) || el.data('tooltip', { title: el.attr('title') });
        const data = el.data('tooltip');
        if (data.title) {
          el.on('mouseover', methods.mouseover).on('mouseout', methods.mouseout);
        }
      });
    },
    mouseover(event) {
      const el = $(this);
      const data = el.data('tooltip');
      el.attr('title', '');
      insertTooltip(el, data.title);
    },
    mouseout(event) {
      const el = $(this);
      const data = el.data('tooltip');
      el.attr('title', data.title);
      if (el.data('tooltipEl')) el.data('tooltipEl').remove();
      el.removeData('tooltipEl');
    },
  };

  function insertTooltip(el, title) {
    const tooltip = $('<div />').addClass('tooltip');
    const info = $('<p />').html(title);
    const tip = $('<div />').addClass('tip');
    tooltip.append(info).append(tip);
    el.data('tooltipEl', tooltip);
    el.append(tooltip);
  }

  $.fn.tooltip = function (method) {
    if (methods[method]) {
      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
    }
    return methods.init.apply(this, arguments);
  };
}
